/**Import react section */
import React from 'react'
import Dropzone from 'react-dropzone'
import PropTypes from 'prop-types'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

/**Import material section */
import Add from '@material-ui/icons/Add'
import { Button, LinearProgress } from '@material-ui/core'

/**Import styles section */
import { ImageStyles } from './ImageStyles'

const ImgThumbnailAdderComponent = ({ onAddEvidence, isLoading }) => {
	const classes = ImageStyles()
	return (
		<div>
			<Dropzone
				multiple={true}
				accept={['.png', '.jpeg', '.jpg']}
				onDrop={(files) => {
					onAddEvidence(files)
				}}
				disabled={isLoading}
			>
				{({ getRootProps, getInputProps }) => (
					<Button className={classes.container} startIcon={<Add />} disabled={isLoading}>
						<div
							{...getRootProps({
								className: 'dropzone'
							})}
						>
							Add Image
							<input {...getInputProps()} capture='environment' />
						</div>
					</Button>
				)}
			</Dropzone>
			{isLoading && <LinearProgress color='primary' style={{ maxWidth: '8rem', marginTop: '-0.5rem' }} />}
		</div>
	)
}

ImgThumbnailAdderComponent.propTypes = {
	onAddEvidence: PropTypes.func.isRequired
}

export default ImgThumbnailAdderComponent
